import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { reducer as formReducer } from 'redux-form'
import shortener from 'reducers/shortener'
import ui from 'reducers/ui'
import user from 'reducers/user'
import { reducer as toastrReducer } from 'react-redux-toastr'

const rootReducer =
    combineReducers({
                      routing: routerReducer,
                      form: formReducer,
                      toastr: toastrReducer,
                      shortener,
                      ui,
                      user
                    });

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js